// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3F4q7","name":"Header_name__2aSJd","birthday":"Header_birthday__YCkBM","skeleton":"Header_skeleton__QeWC9"};